import $ from 'jquery';
import OneVideo from 'Modules/OneVideo';

export default class HpImageModule {
    constructor(wrapper) {
        console.log('Init HpImageModule 🏞');
        const $wrapper = $(wrapper);
        const $videos = $wrapper.find('.video-box');
        const $slides = $wrapper.find('.slides-wrapper');

        if ($slides?.length) {
            $slides.slick({
                dots: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                arrows: false,
            });
        }

        if ($videos?.length) {
            new OneVideo({
                $el: $videos,
                isResponsive: false,
                bgVideo: true,
                autoplay: true,
            });
        }

        // $(window).load(function () {
        // const textModules = document.querySelectorAll('.hp-image-module');
        // const config = {
        //     threshold: [ 0.97 ]
        // }
        // let isLeaving = false;
        // let observer = new IntersectionObserver(function(entries) {
        //     entries.forEach(entry => {
        //         if (entry.isIntersecting) {
        //             isLeaving = true;
        //             console.log('inside text module');
        //             // self.$currentEntry.removeClass('anim-applied')
        //         } else if (isLeaving) {
        //             isLeaving = false;
        //             console.log('outside text module')
        //             self.$currentEntry = $(entry.target);
        //             if(!self.$currentEntry.hasClass('anim-applied')){
        //                 self.$currentEntry.addClass('anim-applied')
        //             }
        //         }
        //     });
        // }, config );
        // // textModules.forEach(textModule => { observer.observe(textModule); });
        // // console.log('textModules[0]',textModules[0]);
        // observer.observe(textModules[0]);
        // });

        let firstModuleSelector = $wrapper.filter('.first-module');
        $(window).on('scroll', function (event) {
            if (
                $(window).scrollTop() >= 10 &&
                !firstModuleSelector.hasClass('anim-applied')
            ) {
                event.stopPropagation();
                firstModuleSelector.addClass('anim-applied');
            }
        });

        $wrapper.find('.arrow').click(function () {
            $('html, body').animate(
                {
                    scrollTop: $wrapper
                        .find('div:first-child')
                        .first()
                        .height(),
                },
                800
            );
        });
    }
}
